module.exports = __webpack_public_path__ + "img/warning-circle-.c1ea6fcd.svg";